export class JoinContestModel {
    public contestId: number;
    public title: string;
    public description: string;
    public tags: string;
    public technicalSpecificationLink: string;
    public agreeToTermsAndConditions: string;
    public agreeToCopyrightTerms: string;
    public designFile: string;
    public designFileUrl: string;
}



// WEBPACK FOOTER //
// ./src/models/contest/join.contest.model.ts